import { GTR } from "../../common/apiUrl/gtr/gtrUrls";
import { API } from "../../common/model/objectTypes";
import { inProcessGatherInfo } from "../../utils/apiDescription/gtr/inProcessGather";
import { API_BASE_URL } from "../../utils/constants";
import { deleteInProcessGathersRequestBody, getAllInProcessGatherResponseBody, getAllInProcessGathersRequestParameter } from "../../utils/gtr/apiObjects";
import { deleteInProcessGatherJsonRequestCurl, inProcessGatherJsonRequestCurl } from "../../utils/gtr/sampleJsonRequest";
import { inProcessGatherJsonResponse } from "../../utils/gtr/sampleJsonResponse";
import { commonRequestHeader, commonResponseBody, createCommonJsonResponseWithData, requestHeaderWithCallback } from "../../utils/objectTypeConstants";

const All : API = {
    name : "In Process Returns",
    url : `${API_BASE_URL}/${GTR.IN_PROCESS.GET_IN_PROCESS_GTR_URL}`,
    method : "GET",
    headers : commonRequestHeader,
    apiInfo : inProcessGatherInfo.getAllInProcessGather,
    requestBody : getAllInProcessGathersRequestParameter,
    responseBody : getAllInProcessGatherResponseBody,
    jsonRequest : inProcessGatherJsonRequestCurl,
    jsonResponse : inProcessGatherJsonResponse
}

const deleteInProcessGather : API = {
    name : "In Process Gather",
    url : `${API_BASE_URL}/${GTR.IN_PROCESS.DELETE_IN_PROCESS_GTR_URL}`,
    method : "DEL",
    headers : requestHeaderWithCallback,
    apiInfo : inProcessGatherInfo.deleteInProcessGather,
    requestBody : deleteInProcessGathersRequestBody,
    responseBody : commonResponseBody,
    jsonRequest : deleteInProcessGatherJsonRequestCurl,
    jsonResponse : createCommonJsonResponseWithData(202)
}


export const getContent = (apiName: string) => {
    switch (apiName) {
        case 'All':
            return All;
        case "In Process Gather":
            return deleteInProcessGather;
    }
}